import HeroSection from '../components/Landing/HeroSection'
import FeaturesSection from '../components/Landing/FeaturesSection'
import PricingSection from '../components/Landing/PricingSection'
import HowItWorksSection from '../components/Landing/HowItWorksSection'
import FAQSection from '../components/Landing/FAQSection'
import Footer from '../components/Landing/Footer'

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <FeaturesSection />
      <PricingSection />
      <HowItWorksSection />
      <FAQSection />
      <Footer />
    </div>
  )
}
